import { render, staticRenderFns } from "./PipeExtraction.vue?vue&type=template&id=b2821f8c&scoped=true"
import script from "./PipeExtraction.vue?vue&type=script&lang=js"
export * from "./PipeExtraction.vue?vue&type=script&lang=js"
import style0 from "./PipeExtraction.vue?vue&type=style&index=0&id=b2821f8c&prod&lang=scss"
import style1 from "./PipeExtraction.vue?vue&type=style&index=1&id=b2821f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2821f8c",
  null
  
)

export default component.exports